<template>
    <div>
        <v-row justify="center" class="absolute">
            <v-dialog v-model="participateDialog" persistent max-width="600"
                @click:outside="$store.dispatch('changeParticipantPom', false)">

                <v-card dark shaped color="black" class="!flex flex-col justify-center items-center p-5">
                    <v-card-title class="!text-2xl !font-Handel text-black !pt-2 capitalize !items-center"
                        :class="`${routeLink}_fortext`">
                        {{ !contestData ? 'Upload Picture For Profile of the Month' : 'Result will be announced soon... ' }}
                    </v-card-title>
                    <v-card-text class="capitalize font-Handel">
                        <span class="  font-bold" :class="`${routeLink}_fortext`">
                            {{ !contestData ? '"if you think you are sexy then show it",' : ' "Wait For The Result" ' }}
                        </span>{{ !contestData ? 'Participate Now in sexiest profile of the month.' : 'You are already participated.' }}
                    </v-card-text>
                    <div class="w-full relative  font-Handel text-2xl" v-if="!contestData">
                        <v-file-input dark v-model="image" accept="image/png, image/jpeg, image/gif , image/svg "
                            placeholder="Upload Picture For POTM" prepend-icon="mdi-camera" label="Picture for POTM"
                            outlined :color="colorAsRoute" class="pt-5 " :class="`${routeLink}_ccolor`">
                            <template v-slot:selection="{ text }">
                                <v-chip small label :color="`${colorAsRoute}`">
                                    {{ text }}
                                </v-chip>
                            </template>
                        </v-file-input>

                    </div>
                    <div class="w-full p-3 " v-else>
                        <v-img :src="contestData.name" position="top center" height="500"></v-img>
                    </div>
                    <v-card-actions class="align-self-end !pr-0">
                        <v-spacer></v-spacer>
                        <v-btn class="font-Handel" text @click="$store.dispatch('changeParticipantPom', false)">
                            Cancel
                        </v-btn>
                        <v-btn v-if="!contestData" :color="colorAsRoute" outlined class="font-Handel"
                            :loading="uploadLoading" @click="participatePOM()">
                            Upload Now
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>
import axios from 'axios'
import errors from '@/store/modules/errors'

export default {
    data() {
        return {
            // dialog: false,
            liked: false,
            image: null,
            uploadLoading: false,
        }
    },
    computed: {
        participateDialog() {
            return this.$store.getters.ParticipantPlayerOfMonth
        },
        contestData() {
            return this.$store.getters.StateUser.data.contest
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },
    methods: {
        async participatePOM() {
            const formData = new FormData();
            formData.append('image', this.image, this.image.name)
            try {
                this.uploadLoading = true;
                const resp = await axios.post('users/contest/upload', formData);
                // console.log(resp)
                this.$store.dispatch('changeParticipantPom', false)
                this.$toast(resp.data.message, {
                    position: "top-left",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: false,
                    closeButton: "button",
                    icon: {
                        iconClass: "mdi mdi-checkbox-multiple-marked-outline",
                        iconChildren: "",
                        iconTag: "i"
                    },
                    rtl: false
                });
                const { data } = await axios.get('profiles')
                // console.log(data);  
                this.$store.commit("setUser", data);

            } catch (error) {
                console.error(error);
                await this.$store.dispatch("errorAction", 'You can only upload one image per month', {
                    root: true,
                })
            } finally {
                this.uploadLoading = false;
            }
        }
    },
}
</script>
<style scoped>
.straight_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(335deg,
            rgb(136 97 0) 0%,
            rgb(255 223 153) 53%,
            rgb(130 93 0 / 97%) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(185deg,
            rgba(0, 240, 255, 1) 55%,
            rgba(0, 156, 255, 1) 75%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
    /* background: rgb(177, 145, 65); */
    background: linear-gradient(208deg,
            rgba(126, 0, 157, 0.9416141456582633) 2%,
            rgba(161, 51, 246, 1) 45%,
            rgba(157, 0, 176, 0.9668242296918768) 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.gay_ccolor:deep(.mdi-camera::before) {
    color: #88c3fa !important;
}

.lesbian_ccolor:deep(.mdi-camera::before) {
    color: #9e2eec !important;
}

.straight_ccolor:deep(.mdi-camera::before) {
    color: #ae8c39 !important;
}
</style>